import { render } from "./Passer.vue?vue&type=template&id=8c809b04&scoped=true"
import script from "./Passer.vue?vue&type=script&lang=js"
export * from "./Passer.vue?vue&type=script&lang=js"

import "./Passer.vue?vue&type=style&index=0&id=8c809b04&scoped=true&lang=css"
import "./Passer.vue?vue&type=style&index=1&id=8c809b04&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c809b04"]])

export default __exports__